export enum LoggingCategory {
  NO_INTERACTION_EVENT = 'NonInteractionEvent',
  // 会員登録に成功した時のアクション
  SUCCEED_SIGNING_UP = 'succeedInSigningUp',
  // ログインした時のアクション
  SUCCEED_SIGNING_IN = 'succeedInSigningIn',
  // 申込みに成功したとき
  SUCCEED_IN_SUBMITTING_FORM = 'succeedInSubmittingForm',
  // ログアウトに成功したとき
  SUCCEED_IN_SIGNING_OUT = 'succeedInSigningOut',
  // ローカルストレージの値がサイト流入時にセットされたとき
  HOTELS_SET_GA_PARAMS = 'hotelsSetGAParams',
  // ローカルストレージの値が変更されたとき
  HOTELS_CHANGE_GA_PARAMS = 'hotelsChangeGAParams',
  // 確認ページ（/order/confirm）から予約情報入力ページへ遷移したとき
  DP_FLIGHT_PROCEED_TO_FILL_RESERVATION_FORM = 'dPFlightProceedToFillReservationForm',
  // 行きのフライト再選択ページ（/order/confirm/going-flights）から帰りのフライト再選択ページへ遷移したとき
  DP_FLIGHT_CHANGE_FLIGHT_GOING = 'dPFlightChangeFlightGoing',
  // 帰りのフライト再選択ページ（/order/confirm/returning-flights）から選択内容の確認ページへ遷移したとき
  DP_FLIGHT_CHANGE_FLIGHT_RETURNING = 'dPFlightChangeFlightReturning',
  // 予約情報入力画面(/order/reservation-information)から支払情報入力ページへ遷移したとき
  DP_FLIGHT_PROCEED_TO_FILL_PAYMENT_FORM = 'dPFlightProceedToFillPaymentForm',
  // 海外DP_v2 確認ページ（/order/confirm）から予約情報入力ページへ遷移したとき
  DP_FLIGHT_PROCEED_TO_FILL_RESERVATION_FORM_V2 = 'dPFlightProceedToFillReservationFormV2',
  // 海外DP_v2 予約情報入力画面(/order/reservation-information)から支払情報入力ページへ遷移したとき
  DP_FLIGHT_PROCEED_TO_FILL_PAYMENT_FORM_V2 = 'dPFlightProceedToFillPaymentFormV2',
  // /order/confirmページで、「選択中の内容を保存・シェア」欄にある「(URLを) コピー」を押下したとき
  DP_FLIGHT_COPY_URL_ON_ORDER_CONFIRM = 'dPFlightCopyUrlOnOrderConfirm',
  // /order/confirmページで、「メールで送信」ボタンを押下したとき（mode=dp-flight-themesなし）
  DP_FLIGHT_SEND_ITINERY_CONFIRMATION_EMAIL_ON_ORDER_CONFIRM = 'dPFlightSendItineraryConfirmationEmailOnOrderConfirm',
  // /order/confirmページで、「メールで送信」ボタンを押下したとき（mode=dp-flight-themesあり）
  DP_FLIGHT_SEND_ITINERY_CONFIRMATION_EMAIL_ON_ORDER_CONFIRM_V2 = 'dPFlightSendItineraryConfirmationEmailOnOrderConfirmV2',
  // /order/confirmページで、「LINEでシェア」ボタンを押下したとき
  DP_FLIGHT_CLICK_TO_SHARE_ON_LINE_ON_ORDER_CONFIRM = 'dPFlightClickToShareOnLineOnOrderConfirm',
  // /order/signページで、「会員登録せずに確認へすすむ」を押下したとき（mode=dp-flight-themesなし）
  DP_FLIGHT_PROCEED_TO_ORDER_CONFIRM_WITHOUT_SIGNUP = 'dPFlightProceedToOrderConfirmWithoutSignup',
  // /order/signページで、「会員登録せずに確認へすすむ」を押下したとき（mode=dp-flight-themesあり）
  DP_FLIGHT_PROCEED_TO_ORDER_CONFIRM_WITHOUT_SIGNUP_V2 = 'dPFlightProceedToOrderConfirmWithoutSignupV2',
}
